import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {Provider as IntlProvider, Manager as IntlManager} from 'packages/@shopify/react-i18n';
import Home, {HomeProps} from './Home';

export interface HomeSectionProps extends HomeProps {
  locale: string;
}

let manager = new IntlManager({locale: 'en-CA'});

function HomeSection(props: HomeSectionProps) {
  const {locale, ...restProps} = props;

  if (locale && locale !== 'en-CA') {
    manager = new IntlManager({locale});
  }

  return (
    <IntlProvider manager={manager}>
      <Home {...restProps} />
    </IntlProvider>
  );
}

export default renderReact('Home', HomeSection);
